/* eslint-disable no-template-curly-in-string */
import React, { useState } from "react";
import styled from "styled-components";
import { Form, Input, Button, Row, Col, Typography } from "antd";

const Title = styled(Typography.Title)`
  && {
    font-size: 36px;
    font-weight: 700;
  }
`;

const StyledButton = styled(Button)`
  margin: 8px 6px;
  width: 96px;
`;

const ButtonContainer = styled(Col)`
  display: flex;
  justify-content: flex-end;
  @media (max-width: 400px) {
    flex-direction: column;
    align-items: center;
  }
  > .ant-form-item {
    margin-bottom: unset;
  }
`;

const AddTelemedicine = (props) => {
  const { addState } = props;
  const [form] = Form.useForm()
  const [cdsOptions, setCdsOptions] = useState([]);
  const onFinish = (values) => {
    const { state } = values;
    const { stateName } = state;
    const stateDetails = {
      name: stateName,
      CDS: [...new Set(cdsOptions.map(o => o.trim()).filter(Boolean))],
    };
    addState(stateDetails);
    form.resetFields();
    setCdsOptions([]);
  };

  const layout = {
    labelCol: {
      span: 12,
    },
    wrapperCol: {
      span: 24,
    },
  };
  const validateMessages = {
    required: "${label} is required!",
  };

  return (
    <Form
      {...layout}
      form={form}
      layout={"vertical"}
      name="nest-messages"
      onFinish={onFinish}
      validateMessages={validateMessages}
    >
      <Title level={2}>Add Telemedicine Categories</Title>
      <Row gutter={24}>
        <Col span={24}>
          <Form.Item
            name={["state", "stateName"]}
            label="Category Name"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input size={"large"} placeholder="Enter Telemedicine Category"/>
          </Form.Item>
        </Col>
        <Col span={24} style={{ marginBottom: '16px' }}>
          <div style={{ marginBottom: '8px', color: 'rgba(0, 0, 0, 0.85)', fontWeight: 'bold' }}>
            CDS Options
          </div>
          {cdsOptions.map((option, index) => (
            <Row key={index} gutter={8} style={{ marginBottom: '8px' }} align="middle">
              <Col flex="auto">
                <Input
                  id={`add-telemedicine-cds-option-${index}-input`}
                  maxLength={175}
                  value={option}
                  onChange={e => {
                    const updated = [...cdsOptions];
                    updated[index] = e.target.value;
                    setCdsOptions(updated);
                  }}
                  placeholder="Enter CDS option (max 175 characters)"
                  size="large"
                />
              </Col>
              <Col>
                <Button
                  id={`add-telemedicine-cds-option-${index}-remove-btn`}
                  danger
                  size="large"
                  onClick={() => setCdsOptions(prev => prev.filter((_, i) => i !== index))}
                >
                  Remove
                </Button>
              </Col>
            </Row>
          ))}
          <Button
            id="add-telemedicine-cds-add-btn"
            type="dashed"
            onClick={() => setCdsOptions(prev => [...prev, ''])}
            style={{ width: '100%' }}
            disabled={cdsOptions.length >= 25}
          >
            + Add CDS Option {cdsOptions.length >= 25 ? '(max 25)' : ''}
          </Button>
        </Col>
        <ButtonContainer span={24}>
          <Form.Item wrapperCol={{ ...layout.wrapperCol}}>
            <StyledButton type="primary" size={"large"} htmlType="submit">
              Add
            </StyledButton>
          </Form.Item>
        </ButtonContainer>
      </Row>
    </Form>
  );
};

export default AddTelemedicine;
